export default __webpack_public_path__ + "static/wearable-df473cc1eb7bf2cb5b250cd4cb770251.png";